export class ServicesFilterInfo {
    searchTerm: string | null;
    categoryIds: number[] | null;
    itemTypeIds: number[] | null;
    serviceType: string | null;
}
